export default {"src":"/_next/static/media/Twitter_Icon.11fcb84b.svg","height":44,"width":44,"blurWidth":0,"blurHeight":0};